module.exports = __webpack_public_path__ + "static/media/sniper.31897a5a.jpg";